<template lang="pug">
  server-data(
    dadata
    ref="serverData"
    :method="getBankList"
    item-value="value"
    search-field-name="query"
    v-slot="{ loading, selectProps, search }"
    @init="autoselect"
  )
    v-autocomplete(
      ref="vAutocomplete"
      v-model="bicData"
      v-bind="{ ...defaultProps, ...selectProps }"
      :search-input.sync="bankValue"
      @blur="resetSearch(bicData, search)"
      @change="(val) => resetSearch(val, search)"
      @update:search-input="(val) => searchHandler(val, search)"
    )
      template(v-slot:item="{ item, attrs, on }")
        v-list-item(
          v-on="on"
          v-bind="attrs"
          active-class="primary--text text--accent-4"
        )
          v-list-item-content
            v-list-item-title {{ item.value }}
            v-list-item-subtitle {{ item.data.payment_city }}

      template(v-slot:selection="{ item }")
        span {{ item.data.bic }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bicData: null,
      bankValue: this.value,
    };
  },
  computed: {
    defaultProps() {
      const { vSelect } = this.$refs;
      return {
        label: 'БИК банка',
        filled: true,
        rounded: true,
        hint: 'Введите БИК или название банка организации',
        'menu-props': {
          'max-width': vSelect?.$el?.clientWidth || 'auto',
        },
        'persistent-hint': true,
        'hide-no-data': true,
        'no-filter': true,
        'return-object': true,
        ...this.$attrs,
      };
    },
  },
  watch: {
    bicData(val) {
      const bic = (val?.data?.bic || null);
      this.$emit('input', bic);
      this.$emit('bankData', val);
    },
  },
  methods: {
    getBankList(params) {
      const data = { ...params, count: 30 };
      return this.$api.contracts.getDadataBic({ ...data });
    },
    searchHandler(val, search) {
      search(val || this.value);
    },
    autoselect(val) {
      if (this.value) {
        [this.bicData] = val;
      }
    },
    resetSearch(val, search) {
      if (!val) search('');
    },
  },
};
</script>
